import type { NextPage } from 'next';
import classNames from 'classnames/bind';
import styles from './404.module.scss';

const cx = classNames.bind(styles);

const Error404Page: NextPage = () => {
  return (
    <div className={cx('error_wrap')}>
      <h2 className={cx('error_code')}>404</h2>
      <p className={cx('error_text')}>This page could not be found.</p>
    </div>
  );
};

export default Error404Page;
